import { Navigate } from "react-router-dom";
import { defaultRouteFor, useAuth } from "./AuthContext";
import type { UserRole } from "../data/schemaTypes";

// RoleGuard restricts a single route (or subtree) to a list of roles.
// Used inside the ProtectedRoute subtree — assumes there is already a
// logged-in user. If the user's role isn't in the allowed list, redirect
// to their default home instead of leaving them on a 403 — keeps the
// navigation experience natural.
export function RoleGuard({
  roles,
  children,
}: {
  roles: UserRole[];
  children: React.ReactNode;
}) {
  const { currentUser } = useAuth();
  if (!currentUser) return null; // ProtectedRoute should have caught this
  if (!roles.includes(currentUser.role)) {
    return <Navigate to={defaultRouteFor(currentUser.role)} replace />;
  }
  return <>{children}</>;
}
